/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Googlesigninfailed3Inputs */

const zh_auth_googlesigninfailed3 = /** @type {(inputs: Auth_Googlesigninfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google 登录失败`)
};

const en_auth_googlesigninfailed3 = /** @type {(inputs: Auth_Googlesigninfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google sign in failed`)
};

const es_auth_googlesigninfailed3 = /** @type {(inputs: Auth_Googlesigninfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al iniciar sesión con Google`)
};

/**
* | output |
* | --- |
* | "Google sign in failed" |
*
* @param {Auth_Googlesigninfailed3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_googlesigninfailed3 = /** @type {((inputs?: Auth_Googlesigninfailed3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Googlesigninfailed3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_googlesigninfailed3(inputs)
	if (locale === "en") return en_auth_googlesigninfailed3(inputs)
	return es_auth_googlesigninfailed3(inputs)
});
export { auth_googlesigninfailed3 as "auth_googleSignInFailed" }